import React, { memo } from "react";

const StopLeftIcon = ({ isLocked, isEditing, isSuggestion, color }) => {
  color = color || (isSuggestion ? "#C2C3C7" : "#606165");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C7.8 2 4 5.22 4 10.2C4 13.52 6.67 17.45 12 22C17.33 17.45 20 13.52 20 10.2C20 5.22 16.2 2 12 2ZM12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12Z"
        fill={color}
      />
    </svg>
  );
};

export default memo(
  StopLeftIcon,
  (p, n) => p.isLocked === n.isLocked && p.isEditing === n.isEditing
);
